import { Button, Card, List, ListItem, Divider } from '@material-tailwind/react';
import { useHistory } from 'react-router-dom';
import { convertirFormato } from '../../ingresos/vista/Ingresos-draft';

export const TablaMobile = ({ registrosAmostrar, cleanUpData }) => {
  const history = useHistory();

  const abrirEgreso = (id_egreso, pathname) => {
    localStorage.setItem('egresoId', JSON.stringify({ id_egreso }));
    history.push({
      pathname,
      state: { fromEgresosSearch: true },
    });
  }

  return (
    <>
      <Button className="mt-2 ml-2 w-48 flex justify-center mb-4 bg-gray-900" onClick={cleanUpData}>
          Regresar 
      </Button>
      <Card className='mt-2'>
        <List>
            {registrosAmostrar.map((item, index) => (
                <>
                    <ListItem key={index} className='mb-1 border-[2px] border-b-gray-300/50'>
                        <div className='f-col space-y-2'>
                            <p><span className='font-bold'>Fecha: </span>{item.fecha}</p>
                            <p><span className='font-bold'>Fondo: </span>{item.fondo}</p>
                            <p><span className='font-bold'>Comprobante: </span>{item.comprobante}</p>
                            <p><span className='font-bold'>Caja: </span>{item.caja}</p>
                            <p><span className='font-bold'>Monto: </span>{convertirFormato(item?.monto?.toString())}</p>
                            <p><span className='font-bold'>Número Egreso: </span>{convertirFormato(item?.numero_egreso?.toString())}</p>
                            <div className='flex gap-2 pt-2'>
                              <Button className='bg-blue-gray-700' onClick={() => abrirEgreso(item.id_egreso, '/egreso/detalle')}>
                                Reimprimir
                              </Button>
                              <Button className='bg-cyan-700' onClick={() => abrirEgreso(item.id_egreso, '/egreso/editar')}>
                                Editar
                              </Button>
                            </div>
                        </div>
                    </ListItem>
                </>
            ))}
        </List>
      </Card>
    </>

  )
}